// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : states package
// =============================================================================
export const parts = true;
import * as reducers from './reducers';
export { reducers };
import * as actions from './actions';
export { actions };
import * as selectors from './selectors';
export { selectors };
import { get } from 'ldash';
export const translateState = (i18n, statusType, statusValue)=>{
    if (statusValue === undefined) {
        return '';
    } else if (statusValue === null) {
        return i18n[`__noentry_${statusType}`] || i18n['__noentry'];
    }
    statusValue = String(statusValue);
    let k = `${statusType}_state_${statusValue}`;
    let res = i18n[k];
    if (!res) {
        res = get(i18n, `${statusType}_state_${statusValue.replace(/ /g, '_')}`, statusValue);
    }
    return res;
};
export { isStateDomainVisible } from './hooks';
